export default __webpack_public_path__ + "static/media/QV_OverExtrusion.d643986c.png";